import "./components/js-form-validator";
import './components/questionsAndAnswers';
import TetherSelect from "tether-select";
import validatorOptions from "./components/validatorOptions";

(function () {
               const contactForm = document.getElementById('contactForm');
               const submitButtons = contactForm.querySelectorAll(
                 '.form__submitButton'
               );
               const validator = new Validator(
                 contactForm,
                 function (err, res) {
                   // Invisible reCAPTCHA: gdy walidacja przeszla, odpal challenge
                   // i powstrzymaj validator od submita — `onSubmit(token)` z
                   // contact.twig wykona contactForm.submit() po sukcesie captchy.
                   if (res && typeof window.grecaptcha !== 'undefined') {
                     window.grecaptcha.execute();
                     return false;
                   }
                   return res;
                 },
                 validatorOptions
               );

               for (const element of contactForm.elements) {
                 element.addEventListener('change', function () {
                   setTimeout(function () {
                     if (validator.validate()) {
                       for (const button of submitButtons)
                         button.disabled = false;
                     } else {
                       for (const button of submitButtons)
                         button.disabled = true;
                     }
                   }, 50);
                 });

                 element.addEventListener('keydown', function () {
                   setTimeout(function () {
                     if (validator.validate()) {
                       for (const button of submitButtons)
                         button.disabled = false;
                     }
                   }, 50);
                 });
               }

               const selectFields = document.querySelectorAll('select');

               for (const select of selectFields) {
                 new TetherSelect({
                   el: select,
                   className: 'select-theme-swm',
                 });
               }
             })();